module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.7a6fdef1.ttf";